export const aspectRatio = {
  '1/1': '1 / 1',
  '5/2': '5 / 2',
  '5/4': '5 / 4',
  '4/5': '4 / 5',
  '8/5': '8 / 5',
  '4/3': '4 / 3',
  '8/3': '8 / 3',
  '3/4': '3 / 4',
  '3/2': '3 / 2',
  '3/1': '3 / 1',
  '2/3': '2 / 3',
  '16/10': '16 / 10',
  '16/5': '16 / 5',
  '10/16': '10 / 16',
  '16/9': '16 / 9',
  '32/9': '32 / 9',
  '9/16': '9 / 16',
  '9/8': '9 / 8',
  '2/1': '2 / 1',
  '4/1': '4 / 1',
  '1/2': '1 / 2',
  '21/9': '21 / 9',
  '14/3': '14 / 3',
  '9/21': '9 / 21',
  '6/7': '6 / 7',
} as const;

export type AspectRatio = keyof typeof aspectRatio;
